import React from 'react';

const AmericanFootball = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.7164 5.72128C4.19522 7.24246 3.44483 9.15285 3.14608 11.0171L8.98328 16.8543C10.8475 16.5555 12.7579 15.8051 14.2791 14.2839C15.8008 12.7622 16.5512 10.8509 16.8497 8.98604L11.0143 3.15062C9.14942 3.44915 7.23815 4.19952 5.7164 5.72128ZM12.6285 2.99663L17.0037 7.37184C17.0421 6.24621 16.9405 5.18856 16.7768 4.30539C16.6742 3.75165 16.2487 3.32611 15.695 3.22351C14.8118 3.05987 13.7541 2.95821 12.6285 2.99663ZM3.21863 15.6998C3.05487 14.816 2.95319 13.7575 2.99183 12.631L7.36934 17.0085C6.24282 17.0472 5.1843 16.9455 4.30051 16.7817C3.74677 16.6791 3.32123 16.2536 3.21863 15.6998ZM1.98925 15.9276C1.45946 13.0684 1.47801 8.19147 4.8323 4.83718C8.18659 1.4829 13.0635 1.46434 15.9227 1.99413C16.9855 2.19105 17.8093 3.01484 18.0062 4.0776C18.536 6.93685 18.5175 11.8138 15.1632 15.168C11.8089 18.5223 6.93197 18.5409 4.07272 18.0111C3.00996 17.8142 2.18617 16.9904 1.98925 15.9276ZM8.33008 12.5534L7.52173 13.3618L6.63763 12.4777L7.44598 11.6693L6.63763 10.861L7.52173 9.97688L8.33008 10.7852L9.1139 10.0014L8.30628 9.19378L9.19037 8.30969L9.998 9.11731L10.7806 8.33469L9.97299 7.52707L10.8571 6.64298L11.6647 7.4506L12.4724 6.64293L13.3565 7.52702L12.5488 8.33469L13.3577 9.14358L12.4736 10.0277L11.6647 9.21879L10.8821 10.0014L11.6908 10.8101L10.8067 11.6942L9.99799 10.8855L9.21417 11.6693L10.0223 12.4775L9.13824 13.3616L8.33008 12.5534Z",
      fill: "white"
    }
  )
);

export { AmericanFootball };
//# sourceMappingURL=AmericanFootball.js.map
